import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-track",
  "use": "icon-track-usage",
  "viewBox": "0 0 15 19",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 19\" id=\"icon-track\"><path fill-rule=\"evenodd\" d=\"M7.5 10a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 .001 5M15 7.451C15 3.335 11.642 0 7.5 0 3.357 0 0 3.335 0 7.451c0 1.111.245 2.166.684 3.114.234.504.537.967.874 1.403h-.023l.207.246c.05.058.1.119.15.176L7.5 19l5.626-6.634c.087-.097.173-.196.254-.298l.083-.1h-.009A7.376 7.376 0 0 0 15 7.451\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol